export function uid() {
  return Math.random().toString(36).slice(2) + Date.now().toString(36);
}

export function saveToStorage(key, value) {
  localStorage.setItem(key, JSON.stringify(value));
}

export function loadFromStorage(key, fallback) {
  try {
    const v = JSON.parse(localStorage.getItem(key) || "null");
    return v ?? fallback;
  } catch (e) {
    return fallback;
  }
}

export function exportCsv(leads) {
  const headers = [
    "id",
    "managerTg",
    "managerName",
    "event",
    "name",
    "company_team",
    "contact",
    "leadType",
    "trafficSource",
    "worksWithUs",
    "commissionModel",
    "notes",
    "createdAt",
    "updatedAt",
  ];
  const rows = leads.map((l) => [
    l.id,
    l.managerTg,
    l.managerName,
    l.event,
    l.name,
    l.company,
    l.contact,
    l.leadType === "Other" && l.customLeadType ? l.customLeadType : l.leadType,
    l.trafficSource === "Other" && l.customTraffic ? l.customTraffic : l.trafficSource,
    l.worksWithUs,
    l.commissionModel === "Other" && l.customCommission ? l.customCommission : (l.commissionModel || ""),
    (l.notes || "").replaceAll("\n", " ").replaceAll('"', "'"),
    l.createdAt,
    l.updatedAt,
  ]);
  const csv = [headers, ...rows]
    .map((r) => r.map((c) => `"${(c ?? "").toString().replaceAll('"', '""')}"`).join(","))
    .join("\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `leads_export_${new Date().toISOString().slice(0, 19)}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
